import {
  Building2,
  Clapperboard,
  Grid2X2,
  ImageIcon,
  KeyRound,
  LayoutDashboard,
  PenSquare,
} from "lucide-react";

export const SOCIAL_STORAGE_KEY = "socialActiveBrandId";

export const socialSections = [
  {
    title: "Ana Menü",
    items: [
      {
        key: "dashboard",
        label: "Dashboard",
        icon: LayoutDashboard,
        path: "/social",
      },
      {
        key: "settings",
        label: "API Ayarları",
        icon: KeyRound,
        path: "/social/settings",
      },
      {
        key: "brand",
        label: "Marka Yönetimi",
        icon: Building2,
        path: "/social/brand",
      },
    ],
  },
  {
    title: "İçerik Araçları",
    items: [
      {
        key: "image",
        label: "Görsel Oluştur",
        icon: ImageIcon,
        path: "/social/create/image",
      },
      {
        key: "video",
        label: "Video Oluştur",
        icon: Clapperboard,
        path: "/social/create/video",
      },
      {
        key: "contents",
        label: "İçerikler",
        icon: Grid2X2,
        path: "/social/contents",
      },
      {
        key: "post",
        label: "Post Editörü",
        icon: PenSquare,
        path: "/social/create/post",
      },
    ],
  },
];

export const getProviderLabel = (provider) => {
  if (provider === "openai") return "OpenAI";
  if (provider === "gemini") return "Gemini";
  return provider;
};

export const buildProviderOptions = (providers, capability) =>
  providers.filter((item) => item.capabilities?.[capability]);

export const getDefaultModelForCapability = (provider, capability) => {
  if (!provider) return "";
  if (capability === "text") return provider.defaultTextModel || provider.models?.text?.[0] || "";
  if (capability === "image") return provider.defaultImageModel || provider.models?.image?.[0] || "";
  if (capability === "video") return provider.defaultVideoModel || provider.models?.video?.[0] || "";
  return "";
};
